import { InjectionToken } from '@angular/core';

export const JQ_TOKEN = new InjectionToken<Object>('jQuery');



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/core/jquery.service.ts